<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "pr-wrapper"
};
</script>

<style>
</style>